<template>
  <div>
    <van-nav-bar :title="t('pesquisar.title')" :border="false" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="m-[12px]">
      <img :src="getAssetsFile('activity/cet2.png')" alt="" class="w-full ">
    </div>
  </div>
</template>
<script setup lang="ts">
import { Button } from "@/components/Button"
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter();
const onClickLeft = () => {
  router.back()
}
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
</style>
<route lang="json5">
    {
      name: 'pesquisar',
      meta: {
        title: 'pesquisar',
        i18n: 'menus.pesquisar'
      },
    }
    </route>
